var _style, _defs, _path, _path2, _path3, _path4, _path5, _polyline, _line, _line2, _line3, _line4, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallMammals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000011028407902135067920000004304164947083558807_);}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000167375332764811096510000013566552781282229899_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000167375332764811096510000013566552781282229899_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2,2.1C22.6,0.8,21.1,0,19.6,0c-1,0-1.9,0.3-2.6,0.9c-0.8,0.7-1.5,1.7-1.8,2.9l-0.9,3.4c-0.8-0.3-1.7-0.4-2.6-0.4 c-0.9,0-1.7,0.1-2.4,0.4l-1-4C7.7,0.8,5.9,0,4.5,0C3,0,1.6,0.8,0.9,2c-0.8,1.3-0.6,3,0.4,4.7l2.8,4.6c-0.7,1.2-1,2.6-1,4 c0,4.7,3.9,8.6,8.6,8.6s8.6-3.9,8.6-8.6c0-1.4-0.3-2.8-1-4L22.4,7C24.1,4.6,23.6,2.9,23.2,2.1z M18.3,11.1c-0.1,0.1-0.1,0.3,0,0.5 c0.7,1.2,1,2.5,1,3.8c0,4.2-3.4,7.7-7.7,7.7c-4.2,0-7.7-3.4-7.7-7.7c0-1.3,0.3-2.6,1-3.8c0.1-0.1,0.1-0.3,0-0.5L2.1,6.3 c-0.9-1.4-1-2.8-0.4-3.8C2.2,1.6,3.3,1,4.5,1C5.9,1,7,1.8,7.3,3.3l1.1,4.5c0,0.1,0.1,0.2,0.3,0.3c0.1,0.1,0.3,0.1,0.4,0 c0.7-0.3,1.5-0.5,2.5-0.5c1,0,2,0.2,2.7,0.5c0.1,0.1,0.3,0.1,0.4,0C14.9,8.2,15,8.1,15,7.9L16.1,4c0.5-1.9,1.9-3.1,3.5-3.1 c1.2,0,2.3,0.6,2.8,1.6c0.6,1.1,0.3,2.5-0.7,3.9L18.3,11.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,8.7L6.6,4.6C6.4,3.6,5.8,3,4.9,3C4.2,3,3.4,3.5,3,4.1C2.8,4.7,2.8,5.2,3.2,5.7L6,9.5c0.1,0.1,0.2,0.2,0.4,0.2 c0.1,0,0.2,0,0.3-0.1l0.7-0.5C7.5,9,7.5,8.9,7.5,8.7z M6.5,8.6L3.9,5.1c-0.1-0.2-0.1-0.4,0-0.6C4,4.2,4.5,3.9,4.9,3.9 c0.4,0,0.7,0.3,0.8,0.8L6.5,8.6L6.5,8.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7,4.2c-0.3-0.6-0.9-1.1-1.6-1.1c-0.8,0-1.4,0.5-1.7,1.4l-1.5,3.9c-0.1,0.2,0,0.4,0.1,0.5l0.8,0.8 c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.2l3-3.6C20.9,5.5,21,4.8,20.7,4.2z M19.7,5.4l-2.7,3.2l-0.2-0.2 l1.4-3.6C18.4,4.3,18.7,4,19.1,4c0.3,0,0.6,0.2,0.8,0.5C20,4.8,20,5.1,19.7,5.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,12.8c-0.3-0.4-1-0.5-1.4-0.2l0,0c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l0,0 C15.7,13.9,15.8,13.3,15.5,12.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2,12.8c-0.3-0.4-1-0.5-1.4-0.2l0,0c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l0,0 C9.4,13.9,9.5,13.3,9.2,12.8z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "12.8,17 11.7,18 10.7,17  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.7,
    y1: 16.9,
    x2: 21.6,
    y2: 15.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.9,
    y1: 18,
    x2: 21.9,
    y2: 19.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8.4,
    y1: 16.9,
    x2: 1.5,
    y2: 15.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8.2,
    y1: 18.1,
    x2: 1.2,
    y2: 19.1
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.8,18c0,0-0.4,3.4,2.2,1.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.7,18c0,0,0.4,3.4-2.2,1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallMammals);
export default __webpack_public_path__ + "static/media/smallMammals.f23c0e3adc0d763b24f1e441a359ca61.svg";
export { ForwardRef as ReactComponent };